import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

function onboardingTarget(step) {
  if (step === "pending_payment") return "/paiement";
  if (!step || step === "active") return "/accueil";
  return "/demarrage";
}

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "?")).get("session_id");
    const offer = sessionStorage.getItem("kavizio_offer") || "";
    api.post("/auth/google/session", { offer }, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        sessionStorage.removeItem("kavizio_offer");
        const target = onboardingTarget(data.user?.company?.onboarding_status);
        window.history.replaceState({}, "", target);
        login(data);
        navigate(target, { replace: true });
      })
      .catch((e) => {
        window.history.replaceState({}, "", "/connexion");
        navigate(`/connexion?erreur=${encodeURIComponent(apiError(e))}`, { replace: true });
      });
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <p className="font-display font-bold text-2xl lowercase animate-pulse">kavizio</p>
    </div>
  );
}
